
import Vue from 'vue';
import FooterText from '@/components/common/FooterText.vue';
import VerifyCodeDialog from '@/components/common/VerifyCodeDialog.vue';
import authenticationService from "@/services/authenticationService";
import { VerificationType } from "@/services/codeVerificationService";
import { UserInfo } from "@/types/User";
import personService from '@/services/portal/personService';

const logoImage = require('@/assets/logo.svg');

export default Vue.extend({
  components: { FooterText, VerifyCodeDialog },
  name: 'LinkUserToMembershipByCode',
  data() {
    return {
      logoImage,
      isProcessing: false,
      showUsername: false,  
      errorMessage: '',
      showAuthorizeCodeModal: false,
      isValid: false,
      memberId: '',
      email: '',
      firstName: '',
      lastName: '',
      emailOnFile: '',
      username: '',  
      challengeId: '',
    };
  },
  computed: {
    userInfo(): UserInfo {
      return this.$store.state.userInfo;
    },
    emailVerificationType: function () {
      return VerificationType.Email;
    }
  },
  created: function() {  
    localStorage.removeItem("membershipLinkPersonId");
  },
  methods: {
    goBack() { this.$router.back(); },
    verifyUsername: async function() {
        this.isProcessing = true;

        const response = await authenticationService.verifyUsername(this.memberId, this.email, this.firstName, this.lastName);
        
        if(!!response.challengeId && !!response.email) {
          this.emailOnFile = response.email;
          this.challengeId = response.challengeId;
          this.errorMessage = '';
          this.isProcessing = false;
          this.showAuthorizeCodeModal = true;
          
        } else {
          this.errorMessage = !!response.messages ? response.messages.join(', ') : '';
          this.isProcessing = false;
          this.showUsername = false;
        }
    },    
    verifyRecoveryCode: personService.verifyAccountRecovery,
    displayUsername: async function(response: any) {
      this.showAuthorizeCodeModal = false;
      this.username = response.username;
      this.showUsername = true;
    },
  },
});
